import { render, staticRenderFns } from "./Snackbars.vue?vue&type=template&id=4ef93b31&"
import script from "./Snackbars.vue?vue&type=script&lang=ts&"
export * from "./Snackbars.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports